import React from "react";
import "./LargeIconButton.scss";
import { Typography } from "@design-system/components/Typography/Typography";
import { Icon } from "@design-system/components/Icon/Icon";

export type LargeIconButtonProps = {
  label: string;
  icon: React.ReactNode;
  iconColor?: 'secondary' | 'primary' | 'purple-cosem' | 'blue-cosem' | 'grey1' | "sky" | "turquoise" | "apple-green" | "green-water" | "green" | 'white' | 'error';
  iconSize?: number;
  onClick?: () => void;
};

export const LargeIconButton: React.FC<LargeIconButtonProps> = ({ label, icon, onClick, iconColor = 'primary', iconSize = 32 }) => {
  return (
    <div className="large-icon-button" onClick={onClick} >
      <Icon icon={icon} size={iconSize} color={iconColor} />
      <Typography intrinsic="h3" className="large-icon-button-label">{label}</Typography>
    </div>
  );
};
